import { animateOnScroll, animateTextByLines } from './functions';

const animateFirstModuleTitle = () => {
  const title = document.querySelector(
    '#modules .modules-grid__item:first-child .card-module__title',
  );
  if (!title) return Promise.resolve();

  const arrow = title.querySelector('.card-module__arrow');
  const textNodes = Array.from(title.childNodes).filter(
    (n) => n.nodeType === Node.TEXT_NODE,
  );

  const text = textNodes.map((n) => n.textContent).join('').trim();
  textNodes.forEach((n) => n.remove());

  let charIndex = 0;
  [...text].forEach((char) => {
    const span = document.createElement('span');
    if (char === ' ') {
      span.className = 'card-module__title-space';
      span.textContent = ' ';
    } else {
      span.className = 'card-module__title-letter';
      span.style.setProperty('--i', charIndex);
      span.textContent = char;
      charIndex++;
    }
    title.insertBefore(span, arrow);
  });

  const totalDuration = (charIndex - 1) * 40 + 350;

  return new Promise((resolve) => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        title.classList.add('is-animating');
        observer.unobserve(title);
        setTimeout(resolve, totalDuration);
      },
      { threshold: 0.5 },
    );

    observer.observe(title);
  });
};

export const initLandingAnimations = () => {
  const modulesH2Done = animateTextByLines('#modules .text-center h2', {
    lineStagger: 300,
  });
  animateTextByLines('#modules .text-center .custom-lead', {
    lineStagger: 300,
    waitFor: modulesH2Done,
  });

  document.querySelectorAll('#modules .modules-grid__item').forEach((item) => {
    animateOnScroll(item, { threshold: 0.1 });
  });

  const titleDone = animateFirstModuleTitle();
  animateTextByLines(
    '#modules .modules-grid__item:first-child .card-module__description',
    { lineStagger: 300, waitFor: titleDone, lineAnimation: 'card-description-line-in 0.5s ease-out forwards' },
  );

  const servicesH2Done = animateTextByLines('#services .platform-services__title', {
    lineStagger: 300,
  });
  animateTextByLines('#services .platform-services__description', {
    lineStagger: 300,
    waitFor: servicesH2Done,
  });

  document.querySelectorAll('#services .platform-service-card').forEach((card) => {
    animateOnScroll(card, { threshold: 0.1 });
  });

  document.querySelectorAll('#cta-banner .cta-banner').forEach((banner) => {
    animateOnScroll(banner, { threshold: 0.1 });
  });

  const licensesH2Done = animateTextByLines('#licenses .licenses__heading', {
    lineStagger: 300,
  });
  animateTextByLines('#licenses .licenses__description', {
    lineStagger: 300,
    waitFor: licensesH2Done,
  });

  document.querySelectorAll('#licenses .license-card').forEach((card) => {
    animateOnScroll(card, { threshold: 0.1 });
  });

  animateOnScroll('#performance');
  animateOnScroll('#performance', {
    childSelector: '.performance-stat',
    stagger: 200,
  });

  [
    '.cta-section__heading',
    '.cta-section__subtitle',
    '.cta-section__button',
    '.performance-heading',
    '.performance-description',
  ].forEach((selector) => animateOnScroll(selector));

  const h1Done = animateTextByLines('#intro .intro__text-wrapper h1', {
    lineStagger: 300,
  });
  const pDone = animateTextByLines('#intro .intro__text-wrapper p', {
    lineStagger: 300,
    waitFor: h1Done,
  });

  const introButtons = document.querySelectorAll('#intro .intro__button');
  introButtons.forEach((btn) => {
    btn.style.opacity = '0';
    btn.style.transform = 'translateY(60px)';
  });
  pDone.then(() => {
    introButtons.forEach((btn) => {
      btn.style.animation = 'performance-fade-in 0.6s ease-out forwards';
    });
  });
};
